/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_cancelEventRequestBody } from '../models/api_cancelEventRequestBody';
import type { api_createEventBeneficiariesRequest } from '../models/api_createEventBeneficiariesRequest';
import type { api_createEventRequest } from '../models/api_createEventRequest';
import type { api_createEventResponse } from '../models/api_createEventResponse';
import type { api_getEventBeneficiaryResponse } from '../models/api_getEventBeneficiaryResponse';
import type { api_getEventResponse } from '../models/api_getEventResponse';
import type { api_getEventSurveyResponse } from '../models/api_getEventSurveyResponse';
import type { api_sendBeneficiaryTokenEmailRequest } from '../models/api_sendBeneficiaryTokenEmailRequest';
import type { api_submitEventBeneficiaryResponseRequest } from '../models/api_submitEventBeneficiaryResponseRequest';
import type { api_updateEventBeneficiariesRequest } from '../models/api_updateEventBeneficiariesRequest';
import type { api_validateEventBeneficiaryTokenResponse } from '../models/api_validateEventBeneficiaryTokenResponse';
import type { db_ListEventsRow } from '../models/db_ListEventsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Events {
    /**
     * Submit an event response
     * @param body Event beneficiary response
     * @returns any Created
     * @throws ApiError
     */
    public static submitEventBeneficiaryResponse(
        body: api_submitEventBeneficiaryResponseRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/event-beneficiaries/response',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Request a new event invite email for a beneficiary
     * @param body Beneficiary Event ID
     * @returns any OK
     * @throws ApiError
     */
    public static sendEventBeneficiaryTokenEmail(
        body: api_sendBeneficiaryTokenEmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/event-beneficiaries/send-event-email',
            body: body,
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an event beneficiary record
     * @param id Event Beneficiary ID
     * @returns api_getEventBeneficiaryResponse OK
     * @throws ApiError
     */
    public static getEventBeneficiary(
        id: number,
    ): CancelablePromise<api_getEventBeneficiaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/event-beneficiaries/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Validate an event beneficiary token
     * @param id Event Beneficiary ID
     * @param token Event Beneficiary Token
     * @returns api_validateEventBeneficiaryTokenResponse OK
     * @throws ApiError
     */
    public static validateEventBeneficiaryToken(
        id: number,
        token: string,
    ): CancelablePromise<api_validateEventBeneficiaryTokenResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/event-beneficiaries/{id}/validate-token/{token}',
            path: {
                'id': id,
                'token': token,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a list of events
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param search Search string
     * @returns db_ListEventsRow OK
     * @throws ApiError
     */
    public static listEvents(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListEventsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/events',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create an event
     * @param body Event details
     * @returns api_createEventResponse Created
     * @throws ApiError
     */
    public static createEvent(
        body: api_createEventRequest,
    ): CancelablePromise<api_createEventResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/events',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an event record
     * @param id Event ID
     * @returns api_getEventResponse OK
     * @throws ApiError
     */
    public static getEvent(
        id: number,
    ): CancelablePromise<api_getEventResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create an event
     * @param id Event ID
     * @param body Event details
     * @returns any Created
     * @throws ApiError
     */
    public static updateEvent(
        id: number,
        body: api_createEventRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an event record
     * @param id Event ID
     * @returns void
     * @throws ApiError
     */
    public static deleteEvent(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create event attendees
     * @param id Event ID
     * @param body Event attendees
     * @returns any Created
     * @throws ApiError
     */
    public static createEventBeneficiaries(
        id: number,
        body: api_createEventBeneficiariesRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/events/{id}/beneficiaries',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update event attendees
     * @param id Event ID
     * @param body Event attendees details
     * @returns void
     * @throws ApiError
     */
    public static updateEventBeneficiaries(
        id: number,
        body: api_updateEventBeneficiariesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/events/{id}/beneficiaries',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get an event record
     * @param id Event ID
     * @param body Event details
     * @returns void
     * @throws ApiError
     */
    public static cancelEvent(
        id: number,
        body: api_cancelEventRequestBody,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/events/{id}/cancel',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Publish an event record
     * @param id Event ID
     * @returns void
     * @throws ApiError
     */
    public static publishEvent(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/events/{id}/publish',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send an event feedback survey
     * @param id Event ID
     * @returns void
     * @throws ApiError
     */
    public static sendFeedbackSurvey(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/events/{id}/send-feedback-survey',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a survey response
     * @param id Event ID
     * @returns api_getEventSurveyResponse OK
     * @throws ApiError
     */
    public static getEventSurvey(
        id: number,
    ): CancelablePromise<api_getEventSurveyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/events/{id}/survey',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
